import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__18f_identity_i18n_6b4e2544__ from "@18f/identity-i18n";
import * as __WEBPACK_EXTERNAL_MODULE_swr_immutable_dd3b8d1e__ from "swr/immutable";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  wF: () => (/* reexport */ full_address_search),
  TJ: () => (/* reexport */ in_person_locations),
  i1: () => (/* reexport */ no_in_person_locations_display),
  Ay: () => (/* binding */ index),
  yF: () => (/* reexport */ formatLocations),
  bR: () => (/* reexport */ requestUspsLocations),
  LW: () => (/* reexport */ snakeCase),
  tX: () => (/* reexport */ transformKeys)
});

;// ./utils.ts
const formatLocations = postOffices => postOffices.map((po, index) => ({
  formattedCityStateZip: `${po.city}, ${po.state}, ${po.zip_code_5}-${po.zip_code_4}`,
  id: index,
  distance: po.distance,
  name: po.name,
  saturdayHours: po.saturday_hours,
  streetAddress: po.address,
  sundayHours: po.sunday_hours,
  weekdayHours: po.weekday_hours
}));
const snakeCase = value => value.split(/(?=[A-Z])/).join('_').toLowerCase();

// snake case the keys of the location
const transformKeys = (location, predicate) => Object.keys(location).reduce((acc, key) => ({
  [predicate(key)]: location[key],
  ...acc
}), {});
;// external "react"
var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const external_react_namespaceObject = x({ ["Children"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.Children), ["cloneElement"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.cloneElement), ["createContext"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.createContext), ["createElement"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.createElement), ["forwardRef"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.forwardRef), ["useCallback"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useCallback), ["useContext"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useContext), ["useEffect"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useEffect), ["useImperativeHandle"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle), ["useMemo"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useMemo), ["useRef"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useRef), ["useState"]: () => (__WEBPACK_EXTERNAL_MODULE_react__.useState) });
;// external "react/jsx-runtime"
var jsx_runtime_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var jsx_runtime_y = (x) => (() => (x))
const jsx_runtime_namespaceObject = jsx_runtime_x({ ["Fragment"]: () => (__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.Fragment), ["jsx"]: () => (__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.jsx), ["jsxs"]: () => (__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.jsxs) });
;// ../components/alert.tsx


function Alert(_ref, ref) {
  let {
    type,
    className,
    isFocusable,
    children,
    textTag = 'p'
  } = _ref;
  const classes = ['usa-alert', type && `usa-alert--${type}`, className].filter(Boolean).join(' ');
  const role = type === 'error' ? 'alert' : 'status';
  const inner = /*#__PURE__*/(0,external_react_namespaceObject.createElement)(textTag, {
    className: 'usa-alert__text'
  }, children);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    ref: ref,
    className: classes,
    role: role,
    tabIndex: isFocusable ? -1 : undefined,
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "usa-alert__body",
      children: inner
    })
  });
}
/* harmony default export */ const components_alert = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(Alert));
;// ../components/page-heading.tsx


function PageHeading(_ref, ref) {
  let {
    children,
    className,
    ...props
  } = _ref;
  const classes = ['page-heading', className].filter(Boolean).join(' ');
  return (
    /*#__PURE__*/
    // Disable reason: Intended as pass-through to heading HTML element.
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0,jsx_runtime_namespaceObject.jsx)("h1", {
      ref: ref,
      ...props,
      className: classes,
      children: children
    })
  );
}
/* harmony default export */ const page_heading = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(PageHeading));
;// external "@18f/identity-i18n"
var identity_i18n_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var identity_i18n_y = (x) => (() => (x))
const identity_i18n_namespaceObject = identity_i18n_x({ ["i18n"]: () => (__WEBPACK_EXTERNAL_MODULE__18f_identity_i18n_6b4e2544__.i18n), ["t"]: () => (__WEBPACK_EXTERNAL_MODULE__18f_identity_i18n_6b4e2544__.t) });
;// ../assets/index.ts
function getAssetPath(path) {
  if (!getAssetPath.cache) {
    try {
      const script = document.querySelector('[data-asset-map]');
      getAssetPath.cache = JSON.parse(script.textContent);
    } catch {
      getAssetPath.cache = {};
    }
  }
  return getAssetPath.cache[path] || path;
}
getAssetPath.cache = undefined;
;// ./components/no-in-person-locations-display.tsx




function NoInPersonLocationsDisplay(_ref) {
  let {
    address
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    className: "grid-row grid-gap grid-gap-1",
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("img", {
      className: "grid-col-2 margin-top-3",
      alt: (0,identity_i18n_namespaceObject.t)('image_description.info_pin_map'),
      width: 65,
      height: 65,
      src: getAssetPath('info-pin-map.svg')
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
      className: "inline-block grid-col-10",
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h2", {
        role: "status",
        children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.none_found', {
          address
        })
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
        children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.none_found_tip')
      })]
    })]
  });
}
/* harmony default export */ const no_in_person_locations_display = (NoInPersonLocationsDisplay);
;// ./components/location-collection.tsx

function LocationCollection(_ref) {
  let {
    children,
    className
  } = _ref;
  const classes = ['usa-collection', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("ul", {
    className: classes,
    children: children
  });
}
/* harmony default export */ const location_collection = (LocationCollection);
;// ../components/button.tsx

function Button(_ref) {
  let {
    href,
    type = href ? undefined : 'button',
    children,
    isBig,
    isFlexibleWidth,
    isWide,
    isOutline,
    isDisabled,
    isUnstyled,
    className,
    ...htmlAttributes
  } = _ref;
  const classes = ['usa-button', isBig && 'usa-button--big', isFlexibleWidth && 'usa-button--flexible-width', isWide && 'usa-button--wide', isOutline && 'usa-button--outline', isUnstyled && 'usa-button--unstyled', className].filter(Boolean).join(' ');
  const tagName = href ? 'a' : 'button';
  return /*#__PURE__*/(0,external_react_namespaceObject.createElement)(tagName, {
    type,
    href,
    disabled: isDisabled,
    className: classes,
    ...htmlAttributes
  }, children);
}
/* harmony default export */ const components_button = (Button);
;// ../spinner-button/spinner-button-element.ts
class SpinnerButtonElement extends HTMLElement {
  #longWaitTimeout;
  connectedCallback() {
    this.form = this.querySelector('form') || this.closest('form');
    this.button.addEventListener('click', this.#preventDefaultIfSpinning);
    this.addEventListener('spinner.start', () => this.toggleSpinner(true));
    this.addEventListener('spinner.stop', () => this.toggleSpinner(false));
    if (this.spinOnClick) {
      if (this.form) {
        this.form.addEventListener('submit', this.showSpinner);
      } else {
        this.button.addEventListener('click', this.showSpinner);
      }
    }
  }
  disconnectedCallback() {
    window.clearTimeout(this.#longWaitTimeout);
    if (this.form) {
      this.form.removeEventListener('submit', this.showSpinner);
    } else {
      this.button.removeEventListener('click', this.showSpinner);
    }
  }
  get button() {
    return this.querySelector('.usa-button');
  }
  get isSpinning() {
    return this.classList.contains('spinner-button--spinner-active');
  }
  get actionMessage() {
    return this.querySelector('.spinner-button__action-message');
  }
  get spinOnClick() {
    return this.getAttribute('spin-on-click') !== 'false';
  }

  /**
   * Time after which to show action message, in milliseconds.
   */
  get longWaitDurationMs() {
    return Number(this.getAttribute('long-wait-duration-ms'));
  }
  showSpinner = () => this.toggleSpinner(true);
  toggleSpinner(isVisible) {
    this.classList.toggle('spinner-button--spinner-active', isVisible);
    this.button.classList.toggle('usa-button--active', isVisible);
    if (isVisible) {
      this.button.setAttribute('aria-disabled', 'true');
    } else {
      this.button.removeAttribute('aria-disabled');
    }
    if (this.actionMessage) {
      this.actionMessage.textContent = isVisible ? this.actionMessage.dataset.message : '';
    }
    window.clearTimeout(this.#longWaitTimeout);
    if (isVisible && Number.isFinite(this.longWaitDurationMs)) {
      this.#longWaitTimeout = window.setTimeout(this.#handleLongWait, this.longWaitDurationMs);
    }
  }
  #handleLongWait = () => {
    this.actionMessage?.classList.remove('usa-sr-only');
  };
  #preventDefaultIfSpinning = event => {
    if (this.isSpinning) {
      event.preventDefault();
    }
  };
}
if (!customElements.get('lg-spinner-button')) {
  customElements.define('lg-spinner-button', SpinnerButtonElement);
}
/* harmony default export */ const spinner_button_element = ((/* unused pure expression or super */ null && (SpinnerButtonElement)));
;// ../spinner-button/spinner-button.tsx





function SpinnerButton(_ref, ref) {
  let {
    spinOnClick = true,
    actionMessage,
    longWaitDurationMs,
    isOutline,
    children,
    ...buttonProps
  } = _ref;
  const elementRef = (0,external_react_namespaceObject.useRef)(null);
  (0,external_react_namespaceObject.useImperativeHandle)(ref, () => elementRef.current);
  const classes = isOutline ? 'spinner-button--outline' : undefined;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("lg-spinner-button", {
    "spin-on-click": spinOnClick,
    "long-wait-duration-ms": longWaitDurationMs,
    ref: elementRef,
    class: classes,
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(components_button, {
      isOutline: isOutline,
      ...buttonProps,
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
        className: "spinner-button__content",
        children: children
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("span", {
        className: "spinner-dots spinner-dots--centered",
        "aria-hidden": "true",
        children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
          className: "spinner-dots__dot"
        }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
          className: "spinner-dots__dot"
        }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
          className: "spinner-dots__dot"
        })]
      })]
    }), actionMessage && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      role: "status",
      "data-message": actionMessage,
      className: "spinner-button__action-message usa-sr-only"
    })]
  });
}
/* harmony default export */ const spinner_button = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(SpinnerButton));
;// ./components/location-collection-item.tsx




function LocationCollectionItem(_ref) {
  let {
    distance,
    formattedCityStateZip,
    handleSelect,
    name,
    saturdayHours,
    selectId,
    streetAddress,
    sundayHours,
    weekdayHours
  } = _ref;
  const numericDistance = distance?.split(' ')[0];
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("li", {
    className: "location-collection-item",
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "usa-collection__body",
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
        className: "grid-row",
        children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
          className: "grid-col-fill",
          children: [numericDistance && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h3", {
            className: "usa-collection__heading margin-bottom-1",
            children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.distance', {
              count: parseFloat(numericDistance)
            })
          }), !distance && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h3", {
            className: "usa-collection__heading margin-bottom-1",
            children: name
          }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            children: streetAddress
          }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            children: formattedCityStateZip
          }), (weekdayHours || saturdayHours || sundayHours) && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h4", {
            children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.retail_hours_heading')
          }), weekdayHours && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            children: `${(0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.retail_hours_weekday')} ${weekdayHours}`
          }), saturdayHours && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            children: `${(0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.retail_hours_sat')} ${saturdayHours}`
          }), sundayHours && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            children: `${(0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.retail_hours_sun')} ${sundayHours}`
          }), handleSelect && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(spinner_button, {
            className: "tablet:display-none margin-top-2 width-full",
            onClick: event => handleSelect(event, selectId),
            type: "submit",
            children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.location_button')
          })]
        }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
          className: "grid-col-auto",
          children: handleSelect && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(spinner_button, {
            className: "display-none tablet:display-inline-block",
            onClick: event => {
              handleSelect(event, selectId);
            },
            type: "submit",
            children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.location_button')
          })
        })]
      })
    })
  });
}
/* harmony default export */ const location_collection_item = (LocationCollectionItem);
;// ./components/in-person-locations.tsx






function InPersonLocations(_ref) {
  let {
    locations,
    onSelect,
    address,
    noInPersonLocationsDisplay: NoInPersonLocationsDisplay,
    resultsHeaderComponent: HeaderComponent,
    resultsSectionHeading: ResultsSectionHeading
  } = _ref;
  if (locations?.length === 0) {
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(NoInPersonLocationsDisplay, {
      address: address
    });
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [ResultsSectionHeading && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(ResultsSectionHeading, {}), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h3", {
      role: "status",
      children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.results_description', {
        address,
        count: locations?.length
      })
    }), HeaderComponent && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(HeaderComponent, {}), onSelect && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
      children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.results_instructions')
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(location_collection, {
      children: (locations || []).map((item, index) => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(location_collection_item, {
        handleSelect: onSelect,
        distance: item.distance,
        streetAddress: item.streetAddress,
        selectId: item.id,
        formattedCityStateZip: item.formattedCityStateZip,
        weekdayHours: item.weekdayHours,
        saturdayHours: item.saturdayHours,
        sundayHours: item.sundayHours
      }, `${index}-${item.name}`))
    })]
  });
}
/* harmony default export */ const in_person_locations = (InPersonLocations);
;// ../react-hooks/use-instance-id.ts

let instances = 0;

/**
 * Returns a string value guaranteed to be unique to all element instances in the application. This
 * can be used in generic unique IDs when needed in, for example, form input label association.
 */
function useInstanceId() {
  return (0,external_react_namespaceObject.useMemo)(() => {
    instances += 1;
    return String(instances);
  }, []);
}
/* harmony default export */ const use_instance_id = (useInstanceId);
;// ../components/text-input.tsx





function TextInput(_ref, ref) {
  let {
    label,
    hint,
    id,
    className,
    ...inputProps
  } = _ref;
  const instanceId = use_instance_id();
  const inputId = id ?? `text-input-${instanceId}`;
  const hintId = id ?? `text-input-hint-${instanceId}`;
  const classes = ['usa-input', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("label", {
      className: "usa-label",
      htmlFor: inputId,
      children: label
    }), hint && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      id: hintId,
      className: "usa-hint",
      children: hint
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("input", {
      ref: ref,
      className: classes,
      id: inputId,
      "aria-describedby": hint && hintId,
      ...inputProps
    })]
  });
}
/* harmony default export */ const text_input = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(TextInput));
;// ../components/select-input.tsx





function SelectInput(_ref, ref) {
  let {
    label,
    hint,
    id,
    className,
    children,
    ...inputProps
  } = _ref;
  const instanceId = use_instance_id();
  const inputId = id ?? `select-input-${instanceId}`;
  const hintId = id ?? `select-input-hint-${instanceId}`;
  const classes = ['usa-select', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("label", {
      className: "usa-label",
      htmlFor: inputId,
      children: label
    }), hint && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      id: hintId,
      className: "usa-hint",
      children: hint
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("select", {
      ref: ref,
      className: classes,
      id: inputId,
      "aria-describedby": hint && hintId,
      ...inputProps,
      children: children
    })]
  });
}
/* harmony default export */ const select_input = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(SelectInput));
;// ../react-hooks/use-did-update-effect.ts


/**
 * A hook behaving the same as useEffect in invoking the given callback when dependencies change,
 * but does not call the callback during initial mount or when unmounting. It can be considered as
 * similar to ReactComponent#componentDidUpdate.
 */
const useDidUpdateEffect = (callback, deps) => {
  const isMounting = (0,external_react_namespaceObject.useRef)(true);
  (0,external_react_namespaceObject.useEffect)(() => {
    if (isMounting.current) {
      isMounting.current = false;
    } else {
      callback();
    }
  }, deps);
};
/* harmony default export */ const use_did_update_effect = (useDidUpdateEffect);
;// ../validated-field/validated-field-element.ts
class ValidatedFieldElement extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.validated-field__input');
    this.inputWrapper = this.querySelector('.validated-field__input-wrapper');
    this.errorMessage = this.ownerDocument.getElementById(this.errorId);
    this.input?.addEventListener('input', () => this.setErrorMessage());
    this.input?.addEventListener('input', () => this.setInputIsValid(true));
    this.input?.addEventListener('invalid', event => this.toggleErrorMessage(event));
  }
  get errorStrings() {
    try {
      return JSON.parse(this.querySelector('.validated-field__error-strings')?.textContent || '');
    } catch {
      return {};
    }
  }
  get errorId() {
    return this.getAttribute('error-id');
  }
  get descriptorIdRefs() {
    return this.input?.getAttribute('aria-describedby')?.split(' ').filter(Boolean) || [];
  }
  get isValid() {
    return this.input?.getAttribute('aria-invalid') !== 'true';
  }

  /**
   * Handles an invalid event, rendering or hiding an error message based on the input's current
   * validity.
   *
   * @param event Invalid event.
   */
  toggleErrorMessage(event) {
    event.preventDefault();
    const errorMessage = this.getNormalizedValidationMessage(this.input);
    const isValid = !errorMessage;
    this.setErrorMessage(errorMessage);
    this.focusOnError(isValid);
    this.setInputIsValid(isValid);
  }

  /**
   * Renders the given message as an error, if present. Otherwise, hides any visible error message.
   *
   * @param message Error message to show, or empty to hide.
   */
  setErrorMessage(message) {
    if (message) {
      this.getOrCreateErrorMessageElement();
      this.errorMessage.textContent = message;
      this.errorMessage.classList.remove('display-none');
    } else if (this.errorMessage) {
      this.errorMessage.textContent = '';
      this.errorMessage.classList.add('display-none');
    }
  }

  /**
   * Sets input attributes corresponding to given validity state.
   *
   * @param isValid Whether input is valid.
   */
  setInputIsValid(isValid) {
    if (isValid === this.isValid) {
      return;
    }
    this.input?.classList.toggle('usa-input--error', !isValid);
    this.input?.setAttribute('aria-invalid', String(!isValid));
    const idRefs = this.descriptorIdRefs.filter(idRef => idRef !== this.errorId);
    if (!isValid) {
      idRefs.push(this.errorId);
    }
    this.input?.setAttribute('aria-describedby', idRefs.join(' '));
  }

  /**
   * Returns a validation message for the given input, normalized to use customized error strings.
   * An empty string is returned for a valid input.
   *
   * @param input Input element.
   *
   * @return Validation message.
   */
  getNormalizedValidationMessage(input) {
    if (!input || input.validity.valid) {
      return '';
    }
    for (const type in input.validity) {
      if (type !== 'valid' && input.validity[type] && this.errorStrings[type]) {
        return this.errorStrings[type];
      }
    }
    return input.validationMessage;
  }

  /**
   * Returns an error message element. If one doesn't already exist, it is created and appended to
   * the root.
   *
   * @return Error message element.
   */
  getOrCreateErrorMessageElement() {
    if (!this.errorMessage) {
      this.errorMessage = this.ownerDocument.createElement('div');
      this.errorMessage.classList.add('usa-error-message');
      this.errorMessage.id = this.errorId;
      this.inputWrapper?.appendChild(this.errorMessage);
    }
    return this.errorMessage;
  }

  /**
   * Focus on this input if it's invalid and another error element
   * does not have focus.
   *
   * @param isValid Whether input is valid.
   */
  focusOnError(isValid) {
    if (!isValid && !document.activeElement?.classList.contains('usa-input--error')) {
      this.input?.focus();
    }
  }
}
if (!customElements.get('lg-validated-field')) {
  customElements.define('lg-validated-field', ValidatedFieldElement);
}
/* harmony default export */ const validated_field_element = ((/* unused pure expression or super */ null && (ValidatedFieldElement)));
;// ../validated-field/validated-field.tsx






/**
 * Returns validity string error messages according to the given input type.
 */
function getErrorMessages(inputType) {
  const messages = {
    valueMissing: inputType === 'checkbox' ? (0,identity_i18n_namespaceObject.t)('forms.validation.required_checkbox') : (0,identity_i18n_namespaceObject.t)('simple_form.required.text')
  };
  if (inputType === 'email') {
    messages.typeMismatch = (0,identity_i18n_namespaceObject.t)('valid_email.validations.email.invalid');
  }
  return messages;
}
function ValidatedField(_ref, forwardedRef) {
  let {
    validate = () => {},
    messages,
    children,
    ...inputProps
  } = _ref;
  const fieldRef = (0,external_react_namespaceObject.useRef)();
  const instanceId = use_instance_id();
  // WILLFIX: we shouldn't be returning the HTML input child below as it could
  //          result in a stale reference. This will be fixed with LG-8494
  (0,external_react_namespaceObject.useImperativeHandle)(forwardedRef, () => fieldRef.current?.input);
  (0,external_react_namespaceObject.useEffect)(() => {
    if (fieldRef.current && fieldRef.current.input) {
      const {
        input
      } = fieldRef.current;
      input.checkValidity = () => {
        let nextError = '';
        try {
          validate(input.value);
        } catch (error) {
          nextError = error.message;
        }
        // this is here in case the component validation state changes during the validate call
        nextError = nextError || input.validity.customError && input.validationMessage || '';
        input.setCustomValidity(nextError);
        return !nextError && (input instanceof HTMLSelectElement ? HTMLSelectElement.prototype.checkValidity.call(input) : HTMLInputElement.prototype.checkValidity.call(input));
      };
      input.reportValidity = () => {
        input.checkValidity();
        if (input instanceof HTMLSelectElement) {
          return HTMLSelectElement.prototype.reportValidity.call(input);
        }
        return HTMLInputElement.prototype.reportValidity.call(input);
      };
    }
  }, [validate]);
  const errorId = `validated-field-error-${instanceId}`;
  const input = children ? external_react_namespaceObject.Children.only(children) : /*#__PURE__*/(0,external_react_namespaceObject.createElement)('input');
  const inputClasses = ['validated-field__input', inputProps.className, input.props.className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("lg-validated-field", {
    ref: fieldRef,
    "error-id": errorId,
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("script", {
      type: "application/json",
      className: "validated-field__error-strings",
      children: JSON.stringify({
        ...getErrorMessages(inputProps.type),
        ...messages
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "validated-field__input-wrapper",
      children: /*#__PURE__*/(0,external_react_namespaceObject.cloneElement)(input, {
        ...inputProps,
        'aria-invalid': false,
        className: inputClasses
      })
    })]
  });
}
/* harmony default export */ const validated_field = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(ValidatedField));
;// ../react-i18n/format-html.ts

/**
 * Given an HTML string and an object of tag names to React component, returns a new React node
 * where the mapped tag names are replaced by the resulting element of the rendered component.
 *
 * Note that this is a very simplistic interpolation of HTML. It only supports self-closing and
 * well-balanced, non-nested tag names, where there are no attributes or excess whitespace within
 * the tag names. The tag name cannot contain regular expression special characters.
 *
 * While the subject markup itself cannot contain attributes, the return value of the component can
 * be any valid React element, with or without additional attributes.
 *
 * @example
 * ```
 * formatHTML('Hello <lg-sparkles>world</lg-sparkles>!', {
 *   'lg-sparkles': ({children}) => <span className="lg-sparkles">{children}</span>
 * });
 * ```
 *
 * @param html HTML to format.
 * @param handlers Mapping of tag names to tag name or component.
 */
function formatHTML(html, handlers) {
  const pattern = new RegExp(`</?(?:${Object.keys(handlers).join('|')})(?: .*?)?/?>`, 'g');
  const matches = html.match(pattern);
  if (!matches) {
    return html;
  }
  const parts = html.split(pattern);

  // Count spliced insertions to use as an offset when replacing parts, since the subsequent loop's
  // iterator is based on matches and the original parts array.
  let spliceCount = 0;
  for (let i = 0; i < matches.length; i++) {
    const match = matches[i];
    const end = match.search(/ |\/?>/);
    const tag = matches[i].slice(1, end);
    const key = `part${i}`;
    const isSelfClosing = match.endsWith('/>');
    if (isSelfClosing) {
      const replacement = /*#__PURE__*/(0,external_react_namespaceObject.createElement)(handlers[tag], {
        key
      });
      parts.splice(i + spliceCount + 1, 0, replacement);
      spliceCount++;
    } else {
      const part = parts[i + spliceCount + 1];
      const replacement = /*#__PURE__*/(0,external_react_namespaceObject.createElement)(handlers[tag], {
        key
      }, part);
      parts[i + spliceCount + 1] = replacement;
      i++; // Increment to skip the closing tag
    }
  }

  return parts.filter(Boolean);
}
/* harmony default export */ const format_html = (formatHTML);
;// ../react-i18n/i18n-context.ts


const I18nContext = /*#__PURE__*/(0,external_react_namespaceObject.createContext)(identity_i18n_namespaceObject.i18n);
I18nContext.displayName = 'I18nContext';
/* harmony default export */ const i18n_context = (I18nContext);
;// ../react-i18n/use-i18n.ts



function useI18n() {
  const {
    t
  } = (0,external_react_namespaceObject.useContext)(i18n_context);
  return {
    t,
    formatHTML: format_html
  };
}
/* harmony default export */ const use_i18n = (useI18n);
;// ../request/index.ts
class ResponseError extends Error {}
class CSRF {
  static get token() {
    return this.#tokenMetaElement?.content || null;
  }
  static set token(value) {
    if (!value) {
      return;
    }
    if (this.#tokenMetaElement) {
      this.#tokenMetaElement.content = value;
    }
    this.#paramInputElements.forEach(input => {
      input.value = value;
    });
  }
  static get param() {
    return this.#paramMetaElement?.content;
  }
  static get #tokenMetaElement() {
    return document.querySelector('meta[name="csrf-token"]');
  }
  static get #paramMetaElement() {
    return document.querySelector('meta[name="csrf-param"]');
  }
  static get #paramInputElements() {
    return document.querySelectorAll(`input[name="${this.param}"]`);
  }
}

/**
 * Returns true if the request associated with the given options would require a valid CSRF token,
 * or false otherwise.
 *
 * @see https://github.com/rails/rails/blob/v7.0.5/actionpack/lib/action_controller/metal/request_forgery_protection.rb#L335-L343
 *
 * @param options Request options
 *
 * @return Whether the request would require a CSRF token
 */
const isCSRFValidatedRequest = options => !!options.method && !['GET', 'HEAD'].includes(options.method.toUpperCase());
async function request(url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    csrf = true,
    json = true,
    read = true,
    ...fetchOptions
  } = options;
  let {
    body,
    headers
  } = fetchOptions;
  headers = new Headers(headers);
  if (csrf && isCSRFValidatedRequest(fetchOptions)) {
    const csrfToken = typeof csrf === 'boolean' ? CSRF.token : csrf();
    if (csrfToken) {
      headers.set('X-CSRF-Token', csrfToken);
    }
  }
  if (json) {
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
    if (typeof json !== 'boolean') {
      body = JSON.stringify(json);
    }
  }
  const response = await fetch(url, {
    ...fetchOptions,
    headers,
    body
  });
  CSRF.token = response.headers.get('X-CSRF-Token');
  if (read) {
    if (!response.ok) {
      const error = new ResponseError();
      error.status = response.status;
      throw error;
    }
    return json ? response.json() : response.text();
  }
  return response;
}
;// ./hooks/use-usps-locations.ts


async function requestUspsLocations(_ref) {
  let {
    locationsURL,
    address
  } = _ref;
  const response = await request(locationsURL, {
    method: 'post',
    json: {
      address: transformKeys(address, snakeCase)
    }
  });
  return formatLocations(response);
}
;// external "swr/immutable"
var immutable_x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var immutable_y = (x) => (() => (x))
const immutable_namespaceObject = immutable_x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_swr_immutable_dd3b8d1e__["default"]) });
;// ./hooks/use-validated-usps-locations.ts




function useValidatedUspsLocations(locationsURL) {
  const [locationQuery, setLocationQuery] = (0,external_react_namespaceObject.useState)(null);
  const validatedAddressFieldRef = (0,external_react_namespaceObject.useRef)(null);
  const validatedCityFieldRef = (0,external_react_namespaceObject.useRef)(null);
  const validatedStateFieldRef = (0,external_react_namespaceObject.useRef)(null);
  const validatedZipCodeFieldRef = (0,external_react_namespaceObject.useRef)(null);
  const checkValidityAndDisplayErrors = (address, city, state, zipCode) => {
    let formIsValid = true;
    const zipCodeIsValid = zipCode.length === 5 && !!zipCode.match(/\d{5}/);
    if (address.length === 0) {
      validatedAddressFieldRef.current?.setCustomValidity((0,identity_i18n_namespaceObject.t)('simple_form.required.text'));
      formIsValid = false;
    } else {
      validatedAddressFieldRef.current?.setCustomValidity('');
    }
    if (city.length === 0) {
      formIsValid = false;
      validatedCityFieldRef.current?.setCustomValidity((0,identity_i18n_namespaceObject.t)('simple_form.required.text'));
    } else {
      validatedCityFieldRef.current?.setCustomValidity('');
    }
    if (state.length === 0) {
      formIsValid = false;
      validatedStateFieldRef.current?.setCustomValidity((0,identity_i18n_namespaceObject.t)('simple_form.required.text'));
    } else {
      validatedStateFieldRef.current?.setCustomValidity('');
    }
    if (zipCode.length === 0) {
      formIsValid = false;
      validatedZipCodeFieldRef.current?.setCustomValidity((0,identity_i18n_namespaceObject.t)('simple_form.required.text'));
    } else {
      validatedZipCodeFieldRef.current?.setCustomValidity('');
    }
    validatedAddressFieldRef.current?.reportValidity();
    validatedCityFieldRef.current?.reportValidity();
    validatedStateFieldRef.current?.reportValidity();
    validatedZipCodeFieldRef.current?.reportValidity();
    const hasInvalidFields = [validatedAddressFieldRef, validatedCityFieldRef, validatedStateFieldRef, validatedZipCodeFieldRef].some(fieldRef => fieldRef.current?.validity?.valid === false);
    return formIsValid && zipCodeIsValid && !hasInvalidFields;
  };
  const handleLocationSearch = (0,external_react_namespaceObject.useCallback)((event, addressValue, cityValue, stateValue, zipCodeValue) => {
    event.preventDefault();
    const address = addressValue.trim();
    const city = cityValue.trim();
    const zipCode = zipCodeValue.trim();
    const formIsValid = checkValidityAndDisplayErrors(address, city, stateValue, zipCode);
    if (!formIsValid) {
      return;
    }
    setLocationQuery({
      address: `${address}, ${city}, ${stateValue} ${zipCode}`,
      streetAddress: address,
      city,
      state: stateValue,
      zipCode
    });
  }, []);
  const {
    data: locationResults,
    isLoading: isLoadingLocations,
    error: uspsError
  } = (0,immutable_namespaceObject["default"])([locationQuery], _ref => {
    let [address] = _ref;
    return address ? requestUspsLocations({
      address,
      locationsURL
    }) : null;
  });
  return {
    locationQuery,
    locationResults,
    uspsError,
    isLoading: isLoadingLocations,
    handleLocationSearch,
    validatedAddressFieldRef,
    validatedCityFieldRef,
    validatedStateFieldRef,
    validatedZipCodeFieldRef
  };
}
;// ./components/full-address-search-input.tsx










function FullAddressSearchInput(_ref) {
  let {
    disabled = false,
    locationsURL,
    onContinue,
    onError = () => undefined,
    onFoundLocations = () => undefined,
    onLoadingLocations = () => undefined,
    registerField = () => undefined,
    usStatesTerritories,
    uspsApiError,
    usesErrorComponent
  } = _ref;
  const {
    t
  } = use_i18n();
  const spinnerButtonRef = (0,external_react_namespaceObject.useRef)(null);
  const [addressValue, setAddressValue] = (0,external_react_namespaceObject.useState)('');
  const [cityValue, setCityValue] = (0,external_react_namespaceObject.useState)('');
  const [stateValue, setStateValue] = (0,external_react_namespaceObject.useState)('');
  const [zipCodeValue, setZipCodeValue] = (0,external_react_namespaceObject.useState)('');
  const {
    locationQuery,
    locationResults,
    uspsError,
    isLoading,
    handleLocationSearch: onSearch,
    validatedAddressFieldRef,
    validatedCityFieldRef,
    validatedStateFieldRef,
    validatedZipCodeFieldRef
  } = useValidatedUspsLocations(locationsURL);
  const inputChangeHandler = input => event => {
    const {
      target
    } = event;
    input(target.value);
  };
  const onAddressChange = inputChangeHandler(setAddressValue);
  const onCityChange = inputChangeHandler(setCityValue);
  const onStateChange = e => setStateValue(e.target.value);
  const onZipCodeChange = inputChangeHandler(setZipCodeValue);
  (0,external_react_namespaceObject.useEffect)(() => {
    spinnerButtonRef.current?.toggleSpinner(isLoading);
    onLoadingLocations(isLoading);
  }, [isLoading]);
  (0,external_react_namespaceObject.useEffect)(() => {
    uspsError && onError(uspsError);
  }, [uspsError]);
  use_did_update_effect(() => {
    onFoundLocations(locationQuery, locationResults);
  }, [locationResults]);
  const handleSearch = (0,external_react_namespaceObject.useCallback)(event => {
    onError(null);
    onSearch(event, addressValue, cityValue, stateValue, zipCodeValue);
  }, [addressValue, cityValue, stateValue, zipCodeValue]);
  const handleContinue = (0,external_react_namespaceObject.useCallback)(event => {
    // Run LocationSelect with null as the location
    onContinue(event, null);
  }, [uspsApiError]);
  const getErroneousAddressChars = () => {
    const addressReStr = validatedAddressFieldRef.current?.pattern;
    if (!addressReStr) {
      return;
    }
    const addressRegex = new RegExp(addressReStr, 'g');
    const errChars = addressValue.replace(addressRegex, '');
    const uniqErrChars = [...new Set(errChars.split(''))].join('');
    return uniqErrChars;
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(validated_field, {
      ref: validatedAddressFieldRef,
      messages: {
        patternMismatch: t('in_person_proofing.form.address.errors.unsupported_chars', {
          char_list: getErroneousAddressChars()
        })
      },
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(text_input, {
        required: true,
        ref: registerField('address'),
        value: addressValue,
        onChange: onAddressChange,
        label: t('in_person_proofing.body.location.po_search.address_label'),
        disabled: disabled,
        maxLength: 255,
        pattern: "[A-Za-z0-9\\-' .\\/#]*"
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(validated_field, {
      ref: validatedCityFieldRef,
      messages: {
        patternMismatch: t('simple_form.required.text')
      },
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(text_input, {
        required: true,
        ref: registerField('city'),
        value: cityValue,
        onChange: onCityChange,
        label: t('in_person_proofing.body.location.po_search.city_label'),
        disabled: disabled,
        maxLength: 50,
        pattern: ".*\\S.*$"
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(validated_field, {
      ref: validatedStateFieldRef,
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(select_input, {
        required: true,
        ref: registerField('state'),
        value: stateValue,
        onChange: onStateChange,
        label: t('in_person_proofing.body.location.po_search.state_label'),
        disabled: disabled,
        children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("option", {
          value: "",
          disabled: true,
          children: t('in_person_proofing.form.address.state_prompt')
        }, "select"), usStatesTerritories.map(_ref2 => {
          let [name, abbr] = _ref2;
          return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("option", {
            value: abbr,
            children: name
          }, abbr);
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(validated_field, {
      ref: validatedZipCodeFieldRef,
      messages: {
        patternMismatch: t('idv.errors.pattern_mismatch.zipcode_five')
      },
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(text_input, {
        required: true,
        className: "tablet:grid-col-5",
        ref: registerField('zip_code'),
        value: zipCodeValue,
        onChange: onZipCodeChange,
        label: t('in_person_proofing.body.location.po_search.zipcode_label'),
        disabled: disabled,
        pattern: "^\\d{5}$",
        maxLength: 5,
        minLength: 5,
        type: "text"
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "margin-y-5",
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(spinner_button, {
        isWide: true,
        isBig: true,
        ref: spinnerButtonRef,
        type: "submit",
        onClick: usesErrorComponent && uspsApiError ? handleContinue : handleSearch,
        spinOnClick: false,
        actionMessage: t('in_person_proofing.body.location.po_search.is_searching_message'),
        longWaitDurationMs: 1,
        children: usesErrorComponent && uspsApiError ? t('in_person_proofing.body.location.po_search.continue_button') : t('in_person_proofing.body.location.po_search.search_button')
      })
    })]
  });
}
;// ../components/link.tsx



function isExternalURL(url) {
  let currentURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  try {
    return new URL(url).hostname !== new URL(currentURL).hostname;
  } catch {
    return false;
  }
}
function Link(_ref) {
  let {
    href,
    isExternal = isExternalURL(href),
    isNewTab = isExternal,
    className,
    children,
    ...anchorProps
  } = _ref;
  const classes = ['usa-link', className, isExternal && 'usa-link--external'].filter(Boolean).join(' ');
  const handleClick = () => {
    // Clear the onbeforeunload event to prevent the "Leave site?" prompt
    if (href === 'choose_id_type') {
      window.onbeforeunload = null;
    }
  };
  let newTabProps;
  if (isNewTab) {
    newTabProps = {
      target: '_blank',
      rel: 'noreferrer'
    };
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("a", {
    href: href,
    ...newTabProps,
    ...anchorProps,
    className: classes,
    onClick: handleClick,
    children: [children, isNewTab && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
      className: "usa-sr-only",
      children: (0,identity_i18n_namespaceObject.t)('links.new_tab')
    })]
  });
}
/* harmony default export */ const components_link = (Link);
;// ./components/skip-usps-facilities-api-error-message.tsx






const helpCenterUrl = 'https://login.gov/help/verify-your-identity/verify-your-identity-in-person/find-a-participating-post-office';
function SkipUspsFacilitiesApiErrorMessage() {
  const {
    formatHTML
  } = use_i18n();
  const translatedErrorBody = (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.usps_facilities_api_error_body_html', {
    link_url: helpCenterUrl
  });
  function formatErrorBody() {
    return formatHTML(translatedErrorBody, {
      a: () => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(components_link, {
        href: helpCenterUrl,
        isExternal: true,
        children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.usps_facilities_api_error_help_center_text')
      })
    });
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    className: "usps-facilities-api-error grid-row",
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "usps-facilities-api-error__svg grid-col-12 tablet:grid-col-auto",
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("img", {
        alt: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.usps_facilities_api_error_icon_alt_text'),
        className: "margin-right-2",
        width: 65,
        height: 65,
        src: getAssetPath('empty-loc.svg')
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
      className: "usps-facilities-api-error__text grid-col-12 tablet:grid-col-fill",
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h2", {
        className: "usps-facilities-api-error__header margin-top-0",
        children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.usps_facilities_api_error_header')
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
        className: "usps-facilities-api-error__body margin-y-0",
        children: formatErrorBody()
      })]
    })]
  });
}
;// ./components/full-address-search.tsx









function FullAddressSearch(_ref) {
  let {
    disabled,
    handleLocationSelect,
    locationsURL,
    noInPersonLocationsDisplay = no_in_person_locations_display,
    onFoundLocations,
    registerField,
    resultsHeaderComponent,
    usStatesTerritories,
    resultsSectionHeading,
    usesErrorComponent
  } = _ref;
  const [apiError, setApiError] = (0,external_react_namespaceObject.useState)(null);
  const [foundAddress, setFoundAddress] = (0,external_react_namespaceObject.useState)(null);
  const [locationResults, setLocationResults] = (0,external_react_namespaceObject.useState)(null);
  const [isLoadingLocations, setLoadingLocations] = (0,external_react_namespaceObject.useState)(false);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [!usesErrorComponent && apiError && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(components_alert, {
      type: "error",
      className: "margin-bottom-4",
      children: (0,identity_i18n_namespaceObject.t)('idv.failure.exceptions.post_office_search_error')
    }), handleLocationSelect ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(page_heading, {
        children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.headings.po_search.location')
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
        children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.po_search_about')
      })]
    }) : /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
      children: (0,identity_i18n_namespaceObject.t)('in_person_proofing.body.location.po_search.address_search_label')
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(FullAddressSearchInput, {
      usStatesTerritories: usStatesTerritories,
      registerField: registerField,
      onContinue: handleLocationSelect,
      onFoundLocations: (address, locations) => {
        setFoundAddress(address);
        setLocationResults(locations);
        onFoundLocations(locations);
        setApiError(null);
      },
      onLoadingLocations: setLoadingLocations,
      onError: setApiError,
      disabled: disabled,
      locationsURL: locationsURL,
      uspsApiError: apiError,
      usesErrorComponent: usesErrorComponent
    }), usesErrorComponent && apiError && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(SkipUspsFacilitiesApiErrorMessage, {}), locationResults && foundAddress && !isLoadingLocations && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(in_person_locations, {
      locations: locationResults,
      onSelect: handleLocationSelect,
      address: foundAddress.address || '',
      noInPersonLocationsDisplay: noInPersonLocationsDisplay,
      resultsHeaderComponent: resultsHeaderComponent,
      resultsSectionHeading: resultsSectionHeading
    })]
  });
}
/* harmony default export */ const full_address_search = (FullAddressSearch);
;// ./index.tsx






/* harmony default export */ const index = (full_address_search);
var __webpack_exports__FullAddressSearch = __webpack_exports__.wF;
var __webpack_exports__InPersonLocations = __webpack_exports__.TJ;
var __webpack_exports__NoInPersonLocationsDisplay = __webpack_exports__.i1;
var __webpack_exports__default = __webpack_exports__.Ay;
var __webpack_exports__formatLocations = __webpack_exports__.yF;
var __webpack_exports__requestUspsLocations = __webpack_exports__.bR;
var __webpack_exports__snakeCase = __webpack_exports__.LW;
var __webpack_exports__transformKeys = __webpack_exports__.tX;
export { __webpack_exports__FullAddressSearch as FullAddressSearch, __webpack_exports__InPersonLocations as InPersonLocations, __webpack_exports__NoInPersonLocationsDisplay as NoInPersonLocationsDisplay, __webpack_exports__default as default, __webpack_exports__formatLocations as formatLocations, __webpack_exports__requestUspsLocations as requestUspsLocations, __webpack_exports__snakeCase as snakeCase, __webpack_exports__transformKeys as transformKeys };
